/* =========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
========================================================================================== */

const mutations = {
  // // ////////////////////////////////////////////
  // // SIDEBAR & UI UX
  // // ////////////////////////////////////////////
  // updateSideBarWidth(state, width) {
  //     state.sidebarWidth = width;
  // },
  // updateSideBarItemsMin(state, val) {
  //     state.sidebarItemsMin = val;
  // },
  // toggleReduceButton(state, val) {
  //     state.reduceButton = val;
  // },
  // toggleIsSideBarActive(state, value) {
  //     state.isSidebarActive = value;
  // },
  // updateTheme(state, val) {
  //     state.theme = val;
  // },
  // updateWindowBreakpoint(state, val) {
  //     state.breakpoint = val;
  // },
  // updatePrimaryColor(state, val) {
  //     state.themePrimaryColor = val;
  // },
  // updateReduce(state, val) {
  //     state.reduce = val;
  // }
  setTitle (state, title) {
    state.title = title
  },
}

export default mutations
